import _ from 'lodash';
import { findById, parseComponents } from '@/builder/item';
import { strategyFor } from '@/builder/products';

function appendWallSpacePanelComponents(str, {
  panelType,
  side,
  wallSpaceSlug,
  panelTypes,
  components,
  preTitleString,
  titleString,
  hasTitle
}) {
  panelTypes.forEach((type) => {
    if (type.slug != panelType) return;
    type.combos.forEach((combo) => {
      if (wallSpaceSlug.search(combo.wallSpace + '-' + side) === -1) return;
      if (_.isNull(combo.components) || !_.isObject(combo.components)) return;
      if (!hasTitle) {
        str += preTitleString;
        str += titleString;
        hasTitle = true;
      }
      for (const id in combo.components) {
        const qty = parseFloat(combo.components[id]);
        const component = findById(components, parseFloat(id));
        for (let i = 1; i <= qty; i++) {
          if (!_.isUndefined(component)) {
            str += '<br>' + (component.displayTitle ?? component.title);
          }
        }
      }
    });
  });
  return { str, hasTitle };
}

export function buildConfigDescription({
  config,
  wallSpace,
  item,
  sectionIndex,
  availableWidth,
  components,
  panelTypes
}) {
  if (!config) return '';

  // code is reflected in ItemService php

  let title = config.title;
  if (!_.isNull(config.displayTitle) && config.displayTitle.length) title = config.displayTitle;
  let str = '';

  str += '<h5>' + title + '</h5>';
  let hasDescription = false;
  if (!_.isNull(config.description) && config.description.length) hasDescription = true;
  if (hasDescription) str += config.description.trim();
  let wrapInParagraph = false;
  let preTitleString = '<br><br>';
  let postContentString = '';
  let lastTag = str.substring(str.length - 4);
  if (lastTag == '</p>') wrapInParagraph = true;
  if (wrapInParagraph) preTitleString = '<p>';
  if (wrapInParagraph) postContentString = '</p>';
  let regex = '/(<p([^>]+)>|</p>)/ig';
  str = str.replace(regex, '');

  if (strategyFor(item.productId).describeConfigComponents) {
    const componentsObject = parseComponents(config.components);

    let cornerComponentStr = '';
    const layoutSection = item.productLayoutSections[sectionIndex];
    const cornerComponent = components.find((obj) => obj.slug === 'walkin-corner-component');
    if (layoutSection.lhsType == 'corner' || layoutSection.rhsType == 'corner') {
      cornerComponentStr = '1 x ' + (cornerComponent.displayTitle ?? cornerComponent.title);
    }

    if (!_.isNull(componentsObject) && _.isObject(componentsObject)) {
      if (preTitleString == '<br><br>' && hasDescription) str += preTitleString;
      let sep = '';
      for (const [id, qty] of Object.entries(componentsObject)) {
        if (parseFloat(qty) > 0) {
          const component = findById(components, parseFloat(id));
          if (!_.isUndefined(component)) {
            str += sep + qty + ' x ' + (component.displayTitle ?? component.title);
            sep = '<br>';
          }
        }
      }
      if (cornerComponentStr.length) {
        str += sep + cornerComponentStr;
      }
      str += postContentString;
    }

    if (!_.isNull(config.materials) && config.materials.length) {
      str += preTitleString;
      str += config.materials;
      str += postContentString;
    }
  }

  const widthDifference = config.maxWidth - availableWidth;
  const variableLowerWidth = (parseFloat(config.variableCabinetMaxWidth) - widthDifference);
  const variableUpperWidth = variableLowerWidth;
  str = str.replaceAll(/{variableLowerWidth}/g, variableLowerWidth);
  str = str.replaceAll(/{variableUpperWidth}/g, variableUpperWidth);

  let fridgeSectionWidth = 900;
  const lhsPanel = config.lhsEndPanelType ?? null;
  const rhsPanel = config.rhsEndPanelType ?? null;
  if (
    (lhsPanel == 'fridge' && wallSpace.slug.search('infill-lhs') !== -1) ||
    (rhsPanel == 'fridge' && wallSpace.slug.search('infill-rhs') !== -1)
  ) {
    fridgeSectionWidth -= 30;
  }
  str = str.replaceAll(/{fridgeSectionWidth}/g, fridgeSectionWidth);

  const layoutSection = item.productLayoutSections[sectionIndex];
  const wallSpaceSlug = item.data.wallSpace.slug;
  const titleString = '<strong>Wall Space Components</strong>';
  let hasTitle = false;

  if (layoutSection.lhsType == 'end' || layoutSection.lhsType == 'endIsland') {
    const result = appendWallSpacePanelComponents(str, {
      panelType: config.lhsEndPanelType,
      side: 'lhs',
      wallSpaceSlug,
      panelTypes,
      components,
      preTitleString,
      titleString,
      hasTitle
    });
    str = result.str;
    hasTitle = result.hasTitle;
  }

  if (layoutSection.rhsType == 'end' || layoutSection.rhsType == 'endIsland') {
    const result = appendWallSpacePanelComponents(str, {
      panelType: config.rhsEndPanelType,
      side: 'rhs',
      wallSpaceSlug,
      panelTypes,
      components,
      preTitleString,
      titleString,
      hasTitle
    });
    str = result.str;
    hasTitle = result.hasTitle;
  }

  if (wrapInParagraph && hasTitle) str += '</p>';

  return str;
}
